import { Component } from "react";

// markup
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Button from "@material-ui/core/Button";

import _ from "underscore";

export default class TableCellReviewApplicationActions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
    };
  }

  handleOpen = () => {
    this.props.getAccountInfoForId(this.props.item.AccountId);
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  handleReject = () => {
    this.props.rejectApplication(this.props.item.Id);
    this.handleClose();
  };

  handleConfirm = () => {
    var acceptedOffers = this.props.item.LoanOffers.filter((offer) => {
      return offer.Accepted;
    });
    var ordersSorted = _.sortBy(acceptedOffers, (offer) => {
      return new Date(offer.DateAccepted);
    });
    // get the last accepted offer
    var acceptedOfferId = ordersSorted[acceptedOffers.length - 1].Id;

    this.props.approveApplication(this.props.item.Id, acceptedOfferId);
    this.handleClose();
  };

  render() {
    let noActionText = "No action Available";
    let isEmptyGuid =
      this.props.item.DirectDebitAccountId ===
      "00000000-0000-0000-0000-000000000000";

    let stateAwaitingReview =
      this.props.item.Stage === "AwaitingCompletion" ||
      this.props.item.Stage === "AwaitingManualReview" ||
      this.props.item.Stage === "OnHold";
    if (isEmptyGuid) noActionText = "User did not select direct debit account";

    let isApproveDisabled = isEmptyGuid; //&& import.meta.env.MODE != 'development';
    const actions = [
      <Button
        key="1"
        variant="outlined"
        color="primary"
        keyboardFocused={true}
        disabled={isApproveDisabled}
        onClick={this.handleConfirm}
      >
        Approve
      </Button>,
      <Button
        key="2"
        variant="outlined"
        keyboardFocused={false}
        onClick={this.handleReject}
      >
        Reject
      </Button>,
      <Button
        key="3"
        variant="outlined"
        keyboardFocused={false}
        onClick={this.handleClose}
      >
        Cancel
      </Button>,
    ];

    return stateAwaitingReview ? (
      <div className="table-cell-actions">
        <Button variant="contained" color="primary" onClick={this.handleOpen}>
          Approve/Reject
        </Button>
        <Dialog
          title="Approve/Reject application"
          modal={false}
          open={this.state.open}
          onClose={this.handleClose}
        >
          <DialogContent>
            {isApproveDisabled ? <h3>{noActionText}</h3> : undefined} <br />
            Approve or reject application id:{this.props.item.Id}
          </DialogContent>
          <DialogActions>{actions}</DialogActions>
        </Dialog>
      </div>
    ) : (
      <div className="table-cell-actions">{noActionText}</div>
    );
  }
}
